import React, { useState } from 'react';
import SEO from '../components/SEO';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthProvider';
import Hero from '../components/Hero';
import Contact from '../components/Contact';

import FAQ from '../components/FAQ';
import WorkflowSection from '../components/WorkflowSection';

import { projects } from '../data/projects';
import ProjectModal from '../components/ProjectModal';
import { ProjectAccordionList } from '../components/ui/project-accordion';

const Landing: React.FC = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedProject, setSelectedProject] = useState<typeof projects[0] | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  React.useEffect(() => {
    if (!loading && user && location.pathname !== '/') {
      console.log('[Landing] User authenticated, redirecting to /:', user.email);
      navigate('/');
    }
  }, [user, loading, navigate, location.pathname]);

  const handleProjectClick = (project: typeof projects[0]) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  if (loading) {
    console.log('[Landing] Auth context is loading');
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <span className="animate-spin inline-block h-8 w-8 border-2 border-white border-t-transparent rounded-full"></span>
        <p className="mt-4 text-white/70">Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white font-sans">
      <main>
        <SEO 
          title="Nuviosites | TDMA - Digital Marketing, SEO & Web Development Agency"
          description="Nuviosites | TDMA is a leading digital agency providing high-performance web development, expert SEO, and custom AI solutions to scale your business."
        />
        <Hero />

        {/* WORKFLOW SECTION */}
        <WorkflowSection />

        {/* WORKS SECTION – white background, dark text */}
        <section className="px-4 sm:px-6 md:px-12 lg:px-16 xl:px-24 py-8 sm:py-12 md:py-16 lg:py-24 xl:py-32 bg-white text-black">
          <ProjectAccordionList
            items={projects
              .filter(p => p.id !== 'motospace' && p.id !== 'themunchies')
              .map((p) => ({
                id: p.id,
                title: p.title,
                category: p.category.text,
                src: p.thumbnailSrc || p.detailImageSrc,
                link: p.slug,
                mediaType: p.mediaType,
                onClick: () => handleProjectClick(p)
              }))}
          />
        </section>

        <FAQ />
        <Contact />
      </main>

      <ProjectModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        project={selectedProject}
      />

    </div>
  );
};

export default Landing;